"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledOption = exports.StyledMenuDropDown = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../../Buttons/Button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledMenuDropDown = _styledComponents.default.div.withConfig({
  displayName: "MenuDropDownstyles__StyledMenuDropDown",
  componentId: "sc-1box9sq-0"
})([".c-down-chevron{margin-left:0.5rem;}.c-options-wrapper{left:0;position:absolute;top:2.75rem;min-width:8rem;width:100%;background:", ";border-bottom-left-radius:", ";border-bottom-right-radius:", ";overflow:hidden;z-index:", ";box-shadow:5px 5px 10px grey;@media only screen and (max-width:", "){top:4rem;}}.c-dropdown-item{width:100%;}.c-dropdown-item:hover{background-color:", ";}.c-mobile-icon{@media only screen and (min-width:", "){display:none;}}.c-desktop-label{text-decoration:none;font-weight:", ";color:", ";@media only screen and (max-width:", "){display:none;}}@media only screen and (min-width:", "){position:relative;}"], function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.dropDown;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.c_background_primary_veryLight;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.c_foreground_overDark;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return props.theme.smallBreak;
});

exports.StyledMenuDropDown = StyledMenuDropDown;
var StyledOption = (0, _styledComponents.default)(_Button.default).withConfig({
  displayName: "MenuDropDownstyles__StyledOption",
  componentId: "sc-1box9sq-1"
})(["width:100%;text-align:left;border-radius:0;border:none;margin:0;font-size:", ";color:", ";padding:", ";&:hover{border:none;}"], function (props) {
  return props.theme.fontSmall;
}, function (props) {
  return props.theme.c_foreground_default;
}, function (props) {
  return props.theme.standardPadding;
});
exports.StyledOption = StyledOption;